export default __webpack_public_path__ + "static/media/handler.1f2ed86b.svg";